import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();


  // Extraire les données de l'état de navigation
  const { state } = location;
  const transaction = state?.transaction || {};
  const produit = state?.produit || {};
  const subscriptionType = state?.subscriptionType || null;
  const newDateFin = state?.newDateFin || null;
  const quantity = state?.quantity || 1;
  const isPreorder = state?.isPreorder || false;
  const phoneNumber = state?.phoneNumber || null;
  const mensuration = state?.mensuration || null;
  const customerFullname = state?.customer_fullname || '';
  const modePaiement = state?.modePaiement || 'momo'; // 'momo' par défaut


  // useEffect(() => {
  //   const paymentSuccess = localStorage.getItem('paymentSuccess');
  //   if (!paymentSuccess) {
  //     navigate('/');
  //     return;
  //   }
  // }, [navigate]);

  useEffect(() => {
    // Pour les paiements en espèces, on n'a pas besoin de vérifier paymentSuccess
    if (modePaiement !== 'especes') {
      const paymentSuccess = localStorage.getItem('paymentSuccess');
      if (!paymentSuccess) {
        navigate('/');
        return;
      }
    }
  }, [navigate, modePaiement]);

  // Formater la date de fin
  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    try {
      return new Date(dateStr).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch (e) {
      console.error('Erreur de formatage de date:', e);
      return null;
    }
  };

  const formattedDateFin = formatDate(newDateFin);

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';

    const cleanPhone = phone.replace(/\D/g, '');

    let formatted = '';
    let digits = '';

    // Si l'utilisateur entre un numéro sans indicatif (ex: 0197472952)
    if (cleanPhone.length === 10 && cleanPhone.startsWith('0')) {
      digits = cleanPhone;
    }

    // Si le numéro commence par 229 (ex: 2290197472952)
    else if (cleanPhone.length === 13 && cleanPhone.startsWith('229')) {
      digits = cleanPhone.slice(3);
    }

    // Si le numéro est déjà 10 chiffres (sans indicatif mais commence sans 0)
    else if (cleanPhone.length === 10) {
      digits = cleanPhone;
    }

    // Si le numéro est déjà 8 chiffres (ancien format)
    else if (cleanPhone.length === 8) {
      digits = '01' + cleanPhone; // on rajoute un "01" pour respecter le format 10 chiffres
    }

    // Formatage si on a 10 chiffres (avec ou sans ajout)
    if (digits.length === 10) {
      formatted = `+229 ${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4, 6)} ${digits.slice(6, 8)} ${digits.slice(8, 10)}`;
    } else {
      formatted = phone; // fallback brut si le format est inattendu
    }

    return formatted;
  };

  // Message personnalisé selon le type de paiement
  const getMessage = () => {
    const total = produit.prix * quantity;
    const preorderAmount = Math.ceil(total / 2);
    const remaining = total - preorderAmount;


    if (modePaiement === 'especes') {
      return (
        <>
          <div className="item"><span className="item-label">Mode de paiement :</span><span className="item-value">
              <span className="badge">Espèces</span>
            </span></div>
          <div className="item">
            <span className="item-label">Produit :</span>
            <span className="item-value">{quantity} × {produit.nom}</span>
          </div>
          {mensuration?.type === 'standard' && (
            <div className="item"><span className="item-label">Taille :</span><span className="item-value">
              <span className="badge">{mensuration.valeur}</span>
            </span></div>
          )}
          {isPreorder ? (
            <>
              <div className="item">
                <span className="item-label">Montant total :</span>
                <span className="item-value">{total.toLocaleString()} FCFA</span>
              </div>
              <div className="item">
                <span className="item-label">Avance payée :</span>
                <span className="item-value">{preorderAmount.toLocaleString()} FCFA</span>
              </div>
              <div className="item">
                <span className="item-label">Reste à payer :</span>
                <span className="item-value">{remaining.toLocaleString()} FCFA</span>
              </div>
            </>
          ) : (
            <div className="item">
              <span className="item-label">Montant payé :</span>
              <span className="item-value">{total.toLocaleString()} FCFA</span>
            </div>
          )}
          <div className="item">
            <span className="item-label">Contact client :</span>
            <span className="item-value">{formatPhoneNumber(phoneNumber)}</span>
          </div>
          <div className="item">
            <span className="item-label">Personne à contacter :</span>
            <span className="item-value">{customerFullname}</span>
          </div>
          <div className="alert alert-success mt-3">
            <p className="mb-0">
              Un agent vous contactera sous peu pour finaliser la livraison.
            </p>
          </div>
        </>
      );
    }

    if (isPreorder) {
      return (
        <>
          <div className="item"><span className="item-label">Produit réservé :</span><span className="item-value">{quantity} × {produit.nom}</span></div>
          {mensuration?.type === 'standard' && (
            <div className="item"><span className="item-label">Taille sélectionnée :</span><span className="item-value">
              <span className="badge">{mensuration.valeur}</span>
            </span></div>
          )}
          <div className="item"><span className="item-label">Montant total :</span><span className="item-value">{total.toLocaleString()} FCFA</span></div>
          <div className="item"><span className="item-label">Montant de l'avance :</span><span className="item-value">{preorderAmount.toLocaleString()} FCFA (50%)</span></div>
          <div className="item"><span className="item-label">Montant restant :</span><span className="item-value">{remaining.toLocaleString()} FCFA</span></div>
          <div className="item"><span className="item-label">Contact client :</span><span className="item-value">{formatPhoneNumber(phoneNumber)}</span></div>
          <div className="item"><span className="item-label">Personne à contacter :</span><span className="item-value">{customerFullname}</span></div>
        </>
      );
    }

    if (subscriptionType) {
      return (
        <>
          <div className="item"><span className="item-label">Type d'abonnement :</span><span className="item-value">{subscriptionType}</span></div>
          <div className="item"><span className="item-label">Produit :</span><span className="item-value">{produit.nom || 'Produit'}</span></div>
          {formattedDateFin && (
            <div className="item"><span className="item-label">Actif jusqu'au :</span><span className="item-value">{formattedDateFin}</span></div>
          )}
        </>
      );
    }

    // Cas normal d'achat
    return (
      <>
        <div className="item"><span className="item-label">Produit acheté :</span><span className="item-value">{quantity} × {produit.nom || 'Produit'}</span></div>
        <div className="item"><span className="item-label">Montant total :</span><span className="item-value">{transaction.total?.toLocaleString() || ''} FCFA</span></div>
        {mensuration?.type === 'standard' && (
          <div className="item"><span className="item-label">Taille sélectionnée :</span><span className="item-value">
            <span className="badge">{mensuration.valeur}</span>
          </span></div>
        )}
        {phoneNumber && (
          <div className="item"><span className="item-label">Contact client :</span><span className="item-value">{formatPhoneNumber(phoneNumber)}</span></div>

        )}
        <div className="item"><span className="item-label">Personne à contacter :</span><span className="item-value">{customerFullname}</span></div>

      </>
    );
  };

  return (
    <div className="container py-5">
      <div className="card-box text-center">
        <FaCheckCircle size={60} className="text-success mb-3" />
        <h3 className="mb-3">
          {modePaiement === 'especes' ? 'Commande confirmée !' : 'Paiement réussi !'}
        </h3>
        <p className="message-wrapper mb-4">{getMessage()}</p>
        {/* Cacher le QR code pour les paiements en espèces */}
        {modePaiement !== 'especes' && transaction.qr_code_url && (
          <div className="mb-4">
            <p className="text-muted">Scannez ce QR code pour accéder aux détails de votre achat :</p>
            <img
              src={`${process.env.REACT_APP_HOTE}${transaction.qr_code_url}`}
              alt="QR Code Achat"
              style={{ maxWidth: '150px', borderRadius: '8px' }}
            />
          </div>
        )}
        <Button
          variant="primary"
          onClick={() => {
            localStorage.removeItem('paymentSuccess');
            localStorage.removeItem('paymentData');
            navigate('/papachigan');
          }}
        >
          Retour à l'accueil 
        </Button>
      </div>

      <style jsx>{`
        .container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #f8f9fa;
}

        .card-box {
  background-color: #fff;
  padding: 30px 20px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  max-width: 600px;
  margin: auto;
}

        .lead {
          font-size: 1.2rem;
          color: #333;
        }
        .text-success {
          color: #28a745 !important;
        }
        .btn-primary {
          background-color: #456bd8;
          border-color: #456bd8;
          transition: background-color 0.3s;
        }
        .btn-primary:hover {
          background-color: #375ab6;
          border-color: #375ab6;
        }
        img {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .item {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          padding: 6px 0;
          font-size: 15px;
        }

        .item-label {
          font-weight: 500;
          color: #333;
          width: 50%;
          text-align: left;
          white-space: nowrap;
        }

        .item-value {
          font-weight: 600;
          color: #000;
          width: 50%;
          text-align: right;
          word-break: break-word;
        }

        @media (max-width: 600px) {
          .item {
            font-size: 14px;
            flex-direction: row;
          }

          .item-label, .item-value {
            width: 48%;
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentSuccess;